export default "__VITE_ASSET__pu_qLOze__"